import { render } from "./EditorSeparator.vue?vue&type=template&id=4898ae2e"
import script from "./EditorSeparator.vue?vue&type=script&lang=js"
export * from "./EditorSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__